export default __webpack_public_path__ + "static/color-roles-and-icons-4400b451d02f0b8d0fd74b1b79372178.png";